import { Stack } from '@mui/material'
import BackgroundGoogleMap from "../../../../components/images/RightGoogleMapSmall.png"


interface RightGoogleMapProps {
  style?: {
    width: {
      xs: string | number
    }
  }
}

const RightGoogleMapSmall = ({ style }: RightGoogleMapProps) => {
  return (
    <Stack
      flexGrow="1"
      sx={{
        backgroundImage: `url(${BackgroundGoogleMap})`, backgroundRepeat: "no-repeat", backgroundSize: "cover",
        width: style?.width.xs,
      }}
    />
  )
}

export default RightGoogleMapSmall